import { Control, FieldPath, FieldValues } from 'react-hook-form'

import { Textarea } from '../textarea'

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '.'

interface FormTextareaProps<T extends FieldValues> {
    className?: string
    control: Control<T>
    name: FieldPath<T>
    label?: React.ReactNode
}

export default function FormTextarea<T extends FieldValues>({ control, name, label, className }: FormTextareaProps<T>) {
    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem className={className}>
                    {label && <FormLabel>{label}</FormLabel>}
                    <FormControl>
                        <Textarea {...field} />
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    )
}
